export default __webpack_public_path__ + "static/media/logo_smartpay.d30129f4.png";